import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { MissionsService } from 'src/app/services/missions.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.page.html',
  styleUrls: ['./ranking.page.scss'],
})
export class RankingPage implements OnInit {

  progress: any;
  rankingResponse: any;
  companyInfo: any;

  constructor(
    public missionService: MissionsService,
    public toolsService: ToolsService,
    public configService: ConfigService,
  ) { }

  async ngOnInit() {
    this.companyInfo = await this.configService.company_info
    this.getPlayerRankingInfo();
  }

  async getPlayerRankingInfo() {
    await this.toolsService.showLoader()
    const response = await this.missionService.getRankingByActivity()
    console.log("Ranking", response)
    this.rankingResponse = response
    this.progress = this.rankingResponse.indicator_position
    await this.toolsService.dismissLoader()
  }
}
